import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CoreService } from '../services';
import { eAppContext, PageInfo } from '../models';

@Injectable({ providedIn: 'root' })

/*
 * is used to prevent unauthenticated users from accessing restricted routes, (in this example it's used in app.routing.ts to protect the home page route)
 * For more information about angular 2+ route guards you can check out this post 'https://blog.thoughtram.io/angular/2016/07/18/guards-in-angular-2.html'
 * NB:  while technically it's possible to bypass this client side authentication check by manually adding a 'currentUser' object to local storage using browser dev tools,
 *      this would only give access to the client side routes/components, it wouldn't give access to any real secure data from the server api because a valid authentication token (JWT)
 *      is required for this.
*/
export class AuthGuard  {
  constructor(private router: Router, private indParam: CoreService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const url: string[] = route.url.join().split(',');

    if (this.indParam.AppParams.token || this.indParam.AppParams.token !== '') {

      //#region check token expiration (after 3 houe and half of stockage)
      const today: Date = new Date();
      const diffMs: number = (today.getTime() - this.indParam.LoginDate.now.getTime()); // milliseconds between now & Christmas
      //const diffDays: number = Math.floor(diffMs / 86400000);
      //const diffHrs: number = Math.floor((diffMs % 86400000) / 3600000);
      const diffMins: number = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      if (diffMins > 210) { // 3 hours and half
        this.indParam.AppParams.token = '';
        this.logout(state);
        return false;
      }
      //#endregion

      //#region check if the current url has already been registered

      let params: string = ''
      let keys: string[] = Object.keys(route.params)
      if (keys && keys.length > 0)
          params = keys.map((key) => key + '=' + route.params[key]).join('&');
      params = params ? '?' + params : '';
      let newUrl = state.url.split(';')[0].split('?')[0] + params;
      if (this.indParam.CurrentUrl.FullUrl === '' || !this.isSameUrl(this.indParam.CurrentUrl.Url, newUrl)) {
        this.indParam.CurrentUrl = new PageInfo(newUrl);
      }
      //#endregion

      //#region stoc the current url for eventual url-reloading management
      const stockedUrl: string = this.indParam.StockedUrl.split('/')[3];

      // cas du mode de facturation uniquement
      if (stockedUrl === 'mode-facturation' && this.indParam.StockedUrl.split('/').length > 4 && state.url.split('/').length === 4) {
        this.indParam.StockedUrl = 'view/empty';
        this.router.navigate(['view/empty']);
      // cas général si changement de page
      } else if (state.url !== this.indParam.StockedUrl)
        this.indParam.StockedUrl = state.url;
      else {
        // cas général si meme page appelé
        // reloading case
        this.indParam.StockedUrl = 'view/empty';
        this.router.navigate(['view/empty']);
      }
      //#endregion

      // authorised so return true
      return true;
    }
    this.logout(state);
    return false;
  }

  //canActivate2(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
  //  //return of(true);
  //  if (this.indParam.AppParams.token || this.indParam.AppParams.token !== '') {

  //    if (route.params && Object.keys(route.params).length > 0 && Object.keys(route.params)[0].toLowerCase() !== 'id')
  //      this.indParam.PageParams = route.params;
  //    else if (route.queryParams && Object.keys(route.queryParams).length > 0)
  //      this.indParam.PageParams = route.queryParams;
  //    else
  //      this.indParam.PageParams = null;

  //    const today: Date = new Date();
  //    const diffMs: number = (today.getTime() - this.indParam.LoginDate.now.getTime()); // milliseconds between now & Christmas
  //    //const diffDays: number = Math.floor(diffMs / 86400000);
  //    //const diffHrs: number = Math.floor((diffMs % 86400000) / 3600000);
  //    const diffMins: number = Math.round(((diffMs % 86400000) % 3600000) / 60000);
  //    if (diffMins > 120) {
  //      this.indParam.AppParams.token = '';
  //      this.logout(state);
  //      return of(false);
  //    }

  //    // authorised so return true
  //    return of(true);
  //  }
  //  this.logout(state);
  //  return of(false);

  //}

  private isSameUrl(url1: string, url2: string): boolean {
    if (url1 === url2)
      return true;

    const u1: number = url1.indexOf(url2);
    const u2: number = url2.indexOf(url1);
    return u1 > -1 || u2 > -1;
  }

  private logout(state: RouterStateSnapshot): void {
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
      case eAppContext.EXTRANET:

        break;
      case eAppContext.QUESTIONNAIRE:
      case eAppContext.ELEARNING:

        break;
      case eAppContext.WEBSTORE:
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        break;
    }
  }
}
